// Cart Drawer Progress Bar js

window.itgCartAvailabilityRefreshTimer = null;
window.itgCartAvailabilityInFlight = false;
window.itgCartAvailabilityObserver = null;
window.itgCartAvailabilityObservedElement = null;
window.itgCartUpdatedListenerBound = false;
window.itgCartAvailabilityPending = false;
window.itgCartAvailabilityUnlockTimer = null;

function itgAssemblyLocationIneligibleMessage() {
    return document.body ? document.body.getAttribute('data-assembly-location-ineligible-message') : '';
}
function itgFreeGiftLabel() {
    return document.body ? document.body.getAttribute('data-free-gift-label') : '';
}

function itgGetCheckoutLockUtils() {
    function fallbackSetCheckoutButtonDisabledState(btn, shouldDisable) {
        btn.disabled = shouldDisable;
        btn.style.opacity = shouldDisable ? 0.5 : 1;
        btn.style.pointerEvents = shouldDisable ? 'none' : 'auto';
    }

    function fallbackResolveTermsCheckboxForCheckoutButton(btn) {
        var current = btn.parentElement;
        while (current && current !== document.body) {
            var scopedCheckbox = current.querySelector('#AgreeToTos');
            if (scopedCheckbox) {
                return scopedCheckbox;
            }
            current = current.parentElement;
        }

        var allCheckoutButtons = Array.from(document.querySelectorAll('button#CheckOut'));
        var allTermsCheckboxes = Array.from(document.querySelectorAll('#AgreeToTos'));
        var buttonIndex = allCheckoutButtons.indexOf(btn);
        if (buttonIndex > -1 && allTermsCheckboxes[buttonIndex]) {
            return allTermsCheckboxes[buttonIndex];
        }

        return document.querySelector('#AgreeToTos');
    }

    return {
        setCheckoutButtonDisabledState:
            typeof window.itgSetCheckoutButtonDisabledState === 'function'
                ? window.itgSetCheckoutButtonDisabledState
                : fallbackSetCheckoutButtonDisabledState,
        resolveTermsCheckboxForCheckoutButton:
            typeof window.itgResolveTermsCheckboxForCheckoutButton === 'function'
                ? window.itgResolveTermsCheckboxForCheckoutButton
                : fallbackResolveTermsCheckboxForCheckoutButton
    };
}

function itgToggleCheckoutAvailabilityPendingFallback(isPending) {
    if (typeof window.itgSetCheckoutAvailabilityPending === 'function') {
        window.itgSetCheckoutAvailabilityPending(isPending);
        return;
    }

    var checkoutBtns = document.querySelectorAll('button#CheckOut');
    var lockUtils = itgGetCheckoutLockUtils();

    checkoutBtns.forEach(function (btn) {
        if (isPending) {
            btn.setAttribute('data-availability-pending-disabled', 'true');
        } else if (btn.getAttribute('data-availability-pending-disabled') === 'true') {
            btn.removeAttribute('data-availability-pending-disabled');
        }

        var hasDeliveryConflict = btn.getAttribute('data-delivery-conflict-disabled') === 'true';
        var termsCheckbox = lockUtils.resolveTermsCheckboxForCheckoutButton(btn);

        if (hasDeliveryConflict || (termsCheckbox && !termsCheckbox.checked)) {
            lockUtils.setCheckoutButtonDisabledState(btn, true);
            return;
        }

        lockUtils.setCheckoutButtonDisabledState(btn, false);
    });
}

function itgScheduleAvailabilityRefresh(options = {}) {
    var delay = typeof options.delay === 'number' ? options.delay : 250;
    var forceReset = options.forceReset !== false;

    if (typeof window.itgSetCheckoutAvailabilityPending === 'function') {
        window.itgSetCheckoutAvailabilityPending(true);
    } else {
        itgToggleCheckoutAvailabilityPendingFallback(true);
    }

    clearTimeout(window.itgCartAvailabilityRefreshTimer);
    window.itgCartAvailabilityRefreshTimer = setTimeout(function () {
        if (window.itgCartAvailabilityInFlight) {
            window.itgCartAvailabilityPending = true;
            return;
        }
        if (typeof window.itgCheckAvailITG !== 'function') {
            window.itgCartAvailabilityPending = false;
            if (typeof window.itgSetCheckoutAvailabilityPending === 'function') {
                window.itgSetCheckoutAvailabilityPending(false);
            } else {
                itgToggleCheckoutAvailabilityPendingFallback(false);
            }
            return;
        }

        window.itgCartAvailabilityInFlight = true;
        window.itgCartAvailabilityPending = false;
        if (forceReset) {
            document
                .querySelectorAll('#itg-shipping-availability, #itg-item-shipping-availability')
                .forEach(function (elm) {
                    elm.remove();
                });
        }

        var releaseInFlight = function () {
            clearTimeout(window.itgCartAvailabilityUnlockTimer);
            window.itgCartAvailabilityUnlockTimer = setTimeout(function () {
                window.itgCartAvailabilityInFlight = false;
                if (typeof window.itgSetCheckoutAvailabilityPending === 'function') {
                    window.itgSetCheckoutAvailabilityPending(false);
                } else {
                    itgToggleCheckoutAvailabilityPendingFallback(false);
                }
                if (window.itgCartAvailabilityPending) {
                    window.itgCartAvailabilityPending = false;
                    itgScheduleAvailabilityRefresh({ forceReset: false, delay: 180 });
                }
            }, 1200);
        };

        var checkResult = window.itgCheckAvailITG();
        if (checkResult && typeof checkResult.then === 'function') {
            checkResult.then(releaseInFlight, releaseInFlight);
            return;
        }

        releaseInFlight();
    }, delay);
}

function itgInitCartAvailabilityObserver() {
    var cartForm = document.getElementById('AjaxCartForm');

    if (
        window.itgCartAvailabilityObserver &&
        window.itgCartAvailabilityObservedElement &&
        !document.body.contains(window.itgCartAvailabilityObservedElement)
    ) {
        window.itgCartAvailabilityObserver.disconnect();
        window.itgCartAvailabilityObserver = null;
        window.itgCartAvailabilityObservedElement = null;
        window.itgCartUpdatedListenerBound = false;
    }

    if (!cartForm) return;

    if (
        window.itgCartAvailabilityObserver &&
        window.itgCartAvailabilityObservedElement === cartForm
    ) {
        return;
    }

    if (window.itgCartAvailabilityObserver) {
        window.itgCartAvailabilityObserver.disconnect();
        window.itgCartAvailabilityObserver = null;
        window.itgCartUpdatedListenerBound = false;
    }

    if (!window.itgCartUpdatedListenerBound) {
        cartForm.addEventListener('cart-updated', function () {
            itgScheduleAvailabilityRefresh({ forceReset: true, delay: 220 });
            if (typeof window.itgScheduleDisableAddButtonsRefresh === 'function') {
                window.itgScheduleDisableAddButtonsRefresh(180);
            }
        });
        window.itgCartUpdatedListenerBound = true;
    }

    window.itgCartAvailabilityObserver = new MutationObserver(function (mutations) {
        var shouldRefresh = false;

        mutations.forEach(function (mutation) {
            if (shouldRefresh) return;

            mutation.addedNodes.forEach(function (node) {
                if (shouldRefresh || node.nodeType !== 1) return;

                if (
                    node.matches('[data-shipping-id], [data-shipping-item-id], pickup-availability-compact') ||
                    node.querySelector('[data-shipping-id], [data-shipping-item-id], pickup-availability-compact') ||
                    node.matches('span.delivery.alert--circle-loading[data-drawer="true"][data-shipping-id]') ||
                    node.querySelector('span.delivery.alert--circle-loading[data-drawer="true"][data-shipping-id]')
                ) {
                    shouldRefresh = true;
                }
            });
        });

        if (shouldRefresh) {
            itgScheduleAvailabilityRefresh({ forceReset: true, delay: 220 });
        }
    });

    window.itgCartAvailabilityObserver.observe(cartForm, {
        childList: true,
        subtree: true,
    });
    window.itgCartAvailabilityObservedElement = cartForm;
}

window.itgScheduleAvailabilityRefresh = itgScheduleAvailabilityRefresh;
window.itgInitCartAvailabilityObserver = itgInitCartAvailabilityObserver;

function itgReadAssemblyEligibility() {
    var eligibility = localStorage.getItem('eligibility');
    return eligibility?.toLowerCase() === 'true'
        ? true
        : eligibility?.toLowerCase() === 'false'
            ? false
            : null;
}

function itgApplyAssemblyEligibilityState(isEligible) {
    var cartWrapper = document.querySelector('#site-cart-sidebar .cart-form');
    var mainCartWrapper = document.querySelector('.template-cart .cart-section');

    if (cartWrapper) {
        cartWrapper.classList.toggle('hide_assembly_variants', !isEligible);
    }
    if (mainCartWrapper) {
        mainCartWrapper.classList.toggle('hide_assembly_variants', !isEligible);
    }

    var mainCartDrawerWrapper = cartWrapper?.querySelector('.cart__items');
    var mainCartPageWrapper = mainCartWrapper?.querySelector('.cart-form__items');
    var hasAssemblyMessage = false;

    if (mainCartPageWrapper) {
        mainCartPageWrapper.querySelectorAll('.cart-form-item').forEach(function (wrapper) {
            var title = (wrapper.dataset.title || '').toLowerCase();

            if (!title.includes('assembly services')) return;

            if (!isEligible) {
                if (!wrapper.querySelector('.assembly-service-msg')) {
                    var message = document.createElement('p');
                    message.className = 'assembly-service-msg';
                    message.textContent = itgAssemblyLocationIneligibleMessage();
                    wrapper.appendChild(message);
                }
                hasAssemblyMessage = true;
                return;
            }

            var existingMessage = wrapper.querySelector('.assembly-service-msg');
            if (existingMessage) {
                existingMessage.remove();
            }
        });
    }

    if (mainCartDrawerWrapper) {
        mainCartDrawerWrapper.querySelectorAll('.itg_cart_item_wrapper').forEach(function (wrapper) {
            var cartItem = wrapper.querySelector('.cart-item');
            if (!cartItem) return;

            var title = (cartItem.dataset.title || '').toLowerCase();
            if (!title.includes('assembly services')) return;

            if (!isEligible) {
                if (!wrapper.querySelector('.assembly-service-msg')) {
                    var message = document.createElement('p');
                    message.className = 'assembly-service-msg';
                    message.textContent = itgAssemblyLocationIneligibleMessage();
                    wrapper.appendChild(message);
                }
                hasAssemblyMessage = true;
                return;
            }

            var existingMessage = wrapper.querySelector('.assembly-service-msg');
            if (existingMessage) {
                existingMessage.remove();
            }
        });
    }

    document.querySelectorAll('button#CheckOut').forEach(function (btn) {
        btn.disabled = hasAssemblyMessage;
        btn.style.opacity = hasAssemblyMessage ? 0.5 : 1;
        btn.style.pointerEvents = hasAssemblyMessage ? 'none' : 'auto';
    });
}

document.addEventListener("DOMContentLoaded", updateProgressBar);
document.addEventListener('DOMContentLoaded', function () {
    itgInitCartAvailabilityObserver();
    setTimeout(function () {
        itgApplyAssemblyEligibilityState(itgReadAssemblyEligibility());
    }, 500);
    var cartForm = document.getElementById('AjaxCartForm');
    if (
        cartForm &&
        (cartForm.querySelector('[data-shipping-id]') ||
            cartForm.querySelector('[data-shipping-item-id]'))
    ) {
        itgScheduleAvailabilityRefresh({ forceReset: false, delay: 200 });
    }
});

// A free gift line is a $0 line of the gift product; a paid line of the same
// product (customer bought one) is not a gift and must never be touched.
function itgIsFreeGiftLine(item, productId) {
    return String(item.product_id) === String(productId) && Number(item.price) === 0;
}

// Locale-aware (e.g. /fr/cart/change) like the rest of the theme's cart writes.
function itgCartChangeJsUrl() {
    const route = window.KROWN?.settings?.routes?.cart_change_url || '/cart/change';
    return route.endsWith('.js') ? route : `${route}.js`;
}

// Gift products offered by the progress-bar steps, with the subtotal each step
// needs. Several steps (and the drawer plus the cart page) can render the same
// gift, so callers dedupe.
function itgConfiguredFreeGifts() {
    return Array.from(
        document.querySelectorAll('.progbar_counter .product_or_discount[data-product-or-discount="product"] .cart_free_product_wrapper')
    )
        .map(wrapper => ({
            productId: wrapper.getAttribute('data-product-id'),
            threshold: parseFloat(wrapper.closest('.progbar_counter').getAttribute('data-amount'))
        }))
        .filter(gift => gift.productId);
}

// One unit per gift once the cart subtotal reaches its step, none below it. An
// unreadable subtotal or threshold keeps the gift rather than taking it away.
function itgAllowedFreeGiftUnits(cart, gifts) {
    const subtotal = Number(cart?.items_subtotal_price) / 100;
    return gifts.map(gift => ({
        productId: gift.productId,
        allowedUnits: isNaN(subtotal) || isNaN(gift.threshold) || subtotal >= gift.threshold ? 1 : 0
    }));
}

// Posts one line change; false when the request fails or Shopify rejects it.
async function itgChangeFreeGiftLine(change, { signal } = {}) {
    try {
        const response = await fetch(itgCartChangeJsUrl(), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(change),
            signal
        });
        if (!response.ok) {
            console.error('Free gift cart change rejected:', response.status, change);
            return false;
        }
        return true;
    } catch (err) {
        console.error('Error changing free gift line:', err);
        return false;
    }
}

// Caps a gift product's free lines at `allowedUnits` (0 or 1): extra quantity on
// the first free line is trimmed and any further free lines are removed. Returns
// true only when Shopify accepted at least one change.
async function itgEnforceFreeGiftLimit(cart, productId, allowedUnits = 1, { signal } = {}) {
    if (!cart || !Array.isArray(cart.items) || !productId) return false;

    const changes = [];
    let remaining = allowedUnits;
    cart.items.filter(item => itgIsFreeGiftLine(item, productId)).forEach(item => {
        const keep = Math.min(Number(item.quantity), remaining);
        remaining -= keep;
        if (Number(item.quantity) > keep) changes.push({ id: item.key, quantity: keep });
    });

    // Sequential: concurrent /cart/change.js calls race each other on the same cart.
    let changed = false;
    for (const change of changes) {
        if (signal?.aborted) break;
        if (await itgChangeFreeGiftLine(change, { signal })) changed = true;
    }
    return changed;
}

// Applies each gift's limit once per distinct product (the most generous limit
// wins when two steps offer the same gift), one product after another.
async function itgEnforceFreeGiftLimits(cart, limits, options = {}) {
    const allowedByProduct = new Map();
    limits.forEach(({ productId, allowedUnits }) => {
        const key = String(productId);
        allowedByProduct.set(key, Math.max(allowedByProduct.get(key) ?? 0, allowedUnits));
    });

    let changed = false;
    for (const [productId, allowedUnits] of allowedByProduct) {
        if (options.signal?.aborted) break;
        if (await itgEnforceFreeGiftLimit(cart, productId, allowedUnits, options)) changed = true;
    }
    return changed;
}

// Line key -> when its removal started. The drawer refresh after a removal re-runs
// the threshold check; if that check still sees the line (a cached or in-flight cart
// read) it must not remove it again, or refresh and removal would loop.
const itgFreeGiftLineRemovals = new Map();
const ITG_FREE_GIFT_REMOVAL_COOLDOWN_MS = 5000;

// Removes a free gift line by its line key. The legacy remove-link click finds
// `#item-<variant id>`, which is the paid line when the same variant was also
// bought; a line key can only ever match the free line.
async function itgRemoveFreeGiftLine(item) {
    if (!item || !item.key || Number(item.price) !== 0) return false;

    const startedAt = itgFreeGiftLineRemovals.get(item.key);
    if (startedAt !== undefined && Date.now() - startedAt < ITG_FREE_GIFT_REMOVAL_COOLDOWN_MS) return false;
    itgFreeGiftLineRemovals.set(item.key, Date.now());

    const removed = await itgChangeFreeGiftLine({ id: item.key, quantity: 0 });
    if (removed) {
        await updateCartDrawer();
    } else {
        // let a later check retry a removal Shopify rejected
        itgFreeGiftLineRemovals.delete(item.key);
    }
    return removed;
}

window.itgRemoveFreeGiftLine = itgRemoveFreeGiftLine;

window.itgFreeGiftState = {
    // a gift add is in flight (blocks every other gift button)
    addInFlight: false,
    // the post-render trim of duplicated gifts, awaited by the checkout check
    pendingTrim: null,
    // the running checkout check, so a double click does not start a second one
    checkoutCheck: null,
    // true only while our own resubmit runs, so the guard lets it through
    bypassCheckoutGuardOnce: false
};

const ITG_CHECKOUT_GIFT_CHECK_TIMEOUT_MS = 4000;

async function itgRunCheckoutGiftCheck(gifts) {
    const state = window.itgFreeGiftState;
    const controller = typeof window.AbortController === 'function' ? new window.AbortController() : null;
    const signal = controller ? controller.signal : undefined;
    let timer;

    const check = (async () => {
        if (state.pendingTrim) await state.pendingTrim;
        if (signal?.aborted) return;
        const cart = await (await fetch('/cart.js', { signal })).json();
        await itgEnforceFreeGiftLimits(cart, itgAllowedFreeGiftUnits(cart, gifts), { signal });
    })();
    const timeout = new Promise(resolve => {
        timer = setTimeout(() => {
            // stop further gift writes so they cannot race the checkout post
            controller?.abort();
            resolve();
        }, ITG_CHECKOUT_GIFT_CHECK_TIMEOUT_MS);
    });

    try {
        await Promise.race([check, timeout]);
    } catch (err) {
        console.error('Error checking free gifts before checkout:', err);
    } finally {
        clearTimeout(timer);
        check.catch(() => {});
    }
}

// The check can redraw the cart (updateCartDrawer swaps #AjaxCartSubtotal), which
// detaches the button that was clicked, so resubmit through a live, enabled one.
function itgFindLiveCheckoutSubmitter(originalForm, originalSubmitter) {
    if (originalSubmitter?.isConnected && originalSubmitter.form?.isConnected && !originalSubmitter.disabled) {
        return originalSubmitter;
    }
    const candidates = Array.from(document.querySelectorAll('[name="checkout"]'))
        .filter(el => el.form && el.form.isConnected && !el.disabled);
    return candidates.find(el => originalForm?.id && el.form.id === originalForm.id) || candidates[0] || null;
}

function itgContinueToCheckout(form, submitter) {
    const liveSubmitter = itgFindLiveCheckoutSubmitter(form, submitter);
    if (!liveSubmitter) {
        // e.g. the terms or availability lock re-disabled checkout; the next click re-runs the check
        console.warn('Checkout is not available after the free gift check; waiting for the next click.');
        return;
    }

    const state = window.itgFreeGiftState;
    const liveForm = liveSubmitter.form;
    state.bypassCheckoutGuardOnce = true;
    try {
        if (typeof liveForm.requestSubmit === 'function') {
            liveForm.requestSubmit(liveSubmitter);
            return;
        }
        const checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'checkout';
        checkoutInput.value = liveSubmitter.value || '';
        liveForm.appendChild(checkoutInput);
        liveForm.submit();
    } catch (err) {
        console.error('Error continuing to checkout:', err);
    } finally {
        // requestSubmit dispatches the submit event synchronously, so the guard has
        // already seen the bypass; clearing it here means it can never stay on.
        state.bypassCheckoutGuardOnce = false;
    }
}

// Last check before checkout: caps free gifts at one per product, and at none when
// the cart is below the gift's step (the page-load trim may still be running, or
// the cart changed in another tab). Fails open after 4s: a slow or failed cart
// read must never block a real sale.
document.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;

    const state = window.itgFreeGiftState;
    if (state.bypassCheckoutGuardOnce) return;

    const gifts = itgConfiguredFreeGifts();
    if (!gifts.length) return;

    event.preventDefault();
    if (state.checkoutCheck) return;

    const form = submitter.form || event.target;
    state.checkoutCheck = itgRunCheckoutGiftCheck(gifts).then(() => {
        state.checkoutCheck = null;
        itgContinueToCheckout(form, submitter);
    });
}, true);

document.addEventListener('click', async (event) => {
    const btn = event.target.closest('.add-to-cart-btn');
    if (!btn) return; // Exit if it's not the button

    event.preventDefault(); // Prevent default behavior only for the button

    // Get variant ID from form input
    const formInput = btn.closest('.itgProduct-card__form')?.querySelector('input[name="id"]');
    if (!formInput) return;

    const variantId = formInput.getAttribute('value');
    if (!variantId) return;

    // One gift add at a time across every rendered gift button (drawer and cart
    // page both render one), otherwise fast clicks each post their own cart add.
    const giftState = window.itgFreeGiftState;
    if (giftState.addInFlight) return;
    giftState.addInFlight = true;
    btn.disabled = true;

    const productId = btn.closest('.cart_free_product_wrapper')?.getAttribute('data-product-id');
    const accordion = btn.closest('.main_free_product_accordion_wrapper');
    const productWrapper = btn.closest('.single_step_product_wrapper');

    // Remove the gift offer right away so it cannot be clicked again mid-request
    if (productWrapper) productWrapper.remove();
    if (accordion && accordion.querySelectorAll('.single_step_product_wrapper').length === 0) {
        accordion.remove();
    }

    try {
        let alreadyInCart = false;
        if (productId) {
            try {
                const cart = await (await fetch('/cart.js')).json();
                alreadyInCart = (cart.items || []).some(item => itgIsFreeGiftLine(item, productId));
            } catch (err) {
                console.error('Error reading cart before adding free gift:', err);
            }
        }

        if (alreadyInCart) {
            await updateCartDrawer();
            await updateProgressBar();
        } else {
            const added = await addProductToCart(variantId, 1);
            // The offer was removed up front; put it back so the customer can retry.
            if (!added) await updateProgressBar();
        }
    } finally {
        giftState.addInFlight = false;
        btn.disabled = false;
    }
});

document.addEventListener('click', async (event) => {
    const button = event.target.closest('.button.assembly-variant-form, .button.warranty-variant-form');
    if (!button) return;

    event.preventDefault();

    const formInput = button.querySelector('input[name="id"]');
    if (!formInput) return;

    const variantId = formInput.getAttribute('value') || formInput.value;
    if (!variantId) return;

    await addServiceVariantToCart(variantId);
});


// ---------------------------------------------------------------------------
// Progress bar and free gift offers
//
// Shared by every flow that changes the cart (drawer refresh, cart form, quick
// add, product page, assembly and warranty adds) through window.itgRefreshCartProgress.
// ---------------------------------------------------------------------------

// Clicks the rendered remove link of the line with this variant id; the fallback
// for a gift line without a line key. True when a link was clicked.
function itgClickLineRemoveLink(productVariantId) {
    try {
        const lineItemElem = document.querySelector(`#item-${productVariantId}`);
        if (!lineItemElem) {
            console.warn(`Line item not found in DOM for variant ${productVariantId}`);
            return false;
        }
        const removeBtn = lineItemElem.querySelector('a.remove, button.remove');
        if (!removeBtn) {
            console.warn(`Remove button not found for variant ${productVariantId}`);
            return false;
        }
        removeBtn.click();
        return true;
    } catch (err) {
        console.error(`Error removing variant ${productVariantId}:`, err);
        return false;
    }
}

// Places each step on the bar and works out the gift offers. A reached gift step
// is offered unless a $0 line of its product is already in the cart (those product
// ids are returned so duplicates can be trimmed). Below a step, its offer and its
// $0 gift lines are removed; paid lines of the gift product are kept.
//
// A gift line with a line key is removed by that key. `removeUnkeyedGiftLine(variantId)`
// handles a line without one: the drawer refresh passes a plain remove-link click,
// page load passes removeProductFromCart, which also redraws the drawer afterwards.
function itgApplyProgressSteps(cart, steps, cartPrice, maxAmountPrice, removeUnkeyedGiftLine) {
    let offersHTML = '';
    const giftProductIdsInCart = [];

    steps.forEach((step, index) => {
        const stepAmount = parseFloat(step.getAttribute('data-amount'));
        if (isNaN(stepAmount) || maxAmountPrice <= 0) return;

        step.style.left = Math.round((stepAmount / maxAmountPrice) * 100) + '%';

        const productElem = step.querySelector('.product_or_discount');
        if (!productElem) return;

        const type = productElem.getAttribute('data-product-or-discount');
        const wrapperId = `cart_drawer_free_product_wrapper_step_${index}`;
        const productId = productElem.querySelector('.cart_free_product_wrapper')?.getAttribute('data-product-id');

        if (cartPrice >= stepAmount && type === 'product') {
            if (cart.items.some(item => itgIsFreeGiftLine(item, productId))) {
                giftProductIdsInCart.push(productId);
            } else {
                offersHTML += `
                    <div class="single_step_product_wrapper" id="${wrapperId}">
                        <div class="free_product_wrapper_inner">
                            ${productElem.innerHTML}
                        </div>
                    </div>`;
            }
            return;
        }

        const staleOffer = document.querySelector('.main_free_product_accordion_wrapper')?.querySelector(`#${wrapperId}`);
        if (staleOffer) staleOffer.remove();

        if (type !== 'product') return;
        cart.items.filter(item => itgIsFreeGiftLine(item, productId)).forEach(item => {
            // by line key when available: the variant-id remove link can hit a paid line of the same variant
            if (item.key) {
                window.itgRemoveFreeGiftLine(item);
            } else {
                removeUnkeyedGiftLine(item.variant_id);
            }
        });
    });

    return { offersHTML, giftProductIdsInCart };
}

function itgBuildFreeGiftAccordion(offersHTML) {
    const accordion = document.createElement('div');
    accordion.classList.add('main_free_product_accordion_wrapper');
    accordion.innerHTML = `
        <div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
            <span class="productTitleItg">${itgFreeGiftLabel()}</span>
            <span class="svg-wrapper accordion_down_icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                    <path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
                </svg>
            </span>
        </div>
        <div class="free_product_wrapper" style="display:block;">
            <div class="free_product_inner_container">
                ${offersHTML}
            </div>
        </div>
    `;

    accordion.querySelector('.headerItg').addEventListener('click', () => {
        const content = accordion.querySelector('.free_product_wrapper');
        content.style.display = content.style.display === 'block' ? 'none' : 'block';
    });

    return accordion;
}

// Renders the "Free Gift" accordion into the drawer wrapper and, on the cart page,
// into a wrapper under the cart items (created on first use). A wrapper with
// nothing to offer is emptied and hidden; one with offers loses the hideWrapper a
// page loaded under the threshold gave it.
function itgRenderFreeGiftOffers(offersHTML) {
    const hasOffers = offersHTML.trim() !== '';
    // The first wrapper in the document: the cart page's own once it exists (page
    // content renders before the drawer), otherwise the drawer's.
    const sidebarWrapper = document.querySelector('.sidebar__free_product_wrapper');
    let cartPageWrapper = document.querySelector('.cart-form__items .sidebar__free_product_wrapper');

    if (!cartPageWrapper && document.body.classList.contains('template-cart')) {
        const cartItemsWrapper = document.querySelector('.cart-form__items');
        if (cartItemsWrapper) {
            cartPageWrapper = document.createElement('div');
            cartPageWrapper.classList.add('sidebar__free_product_wrapper');
            cartItemsWrapper.appendChild(cartPageWrapper);
        }
    }

    [cartPageWrapper, sidebarWrapper].forEach(wrapper => {
        if (!wrapper) return;
        wrapper.innerHTML = '';
        wrapper.classList.toggle('hideWrapper', !hasOffers);
        if (hasOffers) wrapper.appendChild(itgBuildFreeGiftAccordion(offersHTML));
    });
}

// The progress bar the drawer and cart page updates read: the one in the first
// progress wrapper (on the cart page that is the page's own, which renders before
// the drawer). Null when the page has none.
function itgFindCartProgressBar() {
    return document.querySelector('.cart_drawer_progress_bar_inner_wrapper')?.querySelector('.cart_drawer_progress_bar') || null;
}

// The raw data-total-price of the drawer subtotal (e.g. "1,234.5"), or undefined.
function itgReadCartSubtotal() {
    return document.getElementById('AjaxCartSubtotal')?.querySelector('.cart__total')?.getAttribute('data-total-price');
}

function itgParseCartSubtotal(subTotalAmt) {
    return parseFloat(subTotalAmt.replace(/,/g, '').trim());
}

// Fills the bar to the cart's share of the last step, clamped to 0-100%. Left
// alone when either amount is unusable.
function itgSetProgressFill(cartBar, cartPrice, maxAmountPrice) {
    const filledBar = cartBar.querySelector('.cart_drawer_filled_bar');
    if (!filledBar || isNaN(cartPrice) || !(maxAmountPrice > 0)) return;
    filledBar.style.width = Math.min(Math.max((cartPrice * 100) / maxAmountPrice, 0), 100) + '%';
}

async function itgRenderFreeGiftOffersFromCart() {
    const cart = await (await fetch('/cart.js')).json();

    // Read again: the drawer can be redrawn while the cart loads.
    const cartBar = itgFindCartProgressBar();
    if (!cartBar) return;

    const maxAmountPrice = parseFloat(cartBar.getAttribute('data-maxamt'));
    const cartPrice = itgParseCartSubtotal(itgReadCartSubtotal() || '0');

    const steps = cartBar.closest('.cart_drawer_progress_bar_inner_wrapper').querySelectorAll('.progbar_counter');
    if (!steps.length) return;

    const { offersHTML } = itgApplyProgressSteps(cart, steps, cartPrice, maxAmountPrice, itgClickLineRemoveLink);
    itgRenderFreeGiftOffers(offersHTML);
}

// Redraws the progress bar and the free gift offers after the cart changed, from
// the drawer subtotal (#AjaxCartSubtotal). The bar fill and data-cart-price update
// right away; the offers render once /cart.js answers. Returns false, touching
// nothing, when the page has no usable progress bar, or with `requireSteps` when
// the bar has no steps.
function itgRefreshCartProgress({ requireSteps = false } = {}) {
    const subTotalAmt = itgReadCartSubtotal();
    if (!subTotalAmt) return false;

    const cartBar = itgFindCartProgressBar();
    if (!cartBar) return false;

    const maxAmountPrice = parseFloat(cartBar.getAttribute('data-maxamt'));
    if (isNaN(maxAmountPrice) || maxAmountPrice <= 0) return false;

    if (requireSteps && !cartBar.closest('.cart_drawer_progress_bar_inner_wrapper').querySelector('.progbar_counter')) {
        return false;
    }

    itgRenderFreeGiftOffersFromCart().catch(err => {
        console.error('Error rendering free gift offers:', err);
    });

    itgSetProgressFill(cartBar, itgParseCartSubtotal(subTotalAmt), maxAmountPrice);

    cartBar.setAttribute('data-cart-price', subTotalAmt);
    localStorage.setItem('loadedCartPrice', subTotalAmt);
    return true;
}

window.itgRefreshCartProgress = itgRefreshCartProgress;
window.itgFindCartProgressBar = itgFindCartProgressBar;

    function newUpdateCartDrawer(){
        setTimeout(function () {
            itgApplyAssemblyEligibilityState(itgReadAssemblyEligibility());
        }, 500);

        itgRefreshCartProgress();
    }

    function updateCartQty(item, newQty){

        let alert = null;
        document.getElementById('AjaxCartForm').classList.add('processing');
        if ( document.getElementById('AjaxCartForm').querySelector('.alert') ) {
            document.getElementById('AjaxCartForm').querySelector('.alert').remove();
        }

        const body = JSON.stringify({
            line: parseInt(item.dataset.line),
            quantity: newQty
        });

        fetch(KROWN.settings.routes.cart_change_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
                body
            })
            .then(response => response.json())
            .then(response => {
                if ( response.status == 422 ) {
                    // wrong stock logic alert
                    alert = document.createElement('span');
                    alert.classList.add('alert', 'alert--error');
                    if ( typeof response.description === 'string' ) {
                        alert.innerHTML = response.description;
                    } else {
                        alert.innerHTML = response.message;
                    }
                }
                return fetch('?section_id=helper-cart');
            })
            .then(response => response.text())
            .then(text => {

                const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
                const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

                const cartItems = document.getElementById('AjaxCartForm');
                cartItems.innerHTML = cartFormInnerHTML;
                rebindAjaxCartForm(cartItems);

                document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
                    elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
                });
                document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
                    elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
                });

                if ( alert !== null ) {	
                    document.getElementById('AjaxCartForm').prepend(alert);
                } 

                document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
                newUpdateCartDrawer() ;
                triggerAvailabilityRefresh({ forceReset: true, delay: 220 });

                const event = new Event('cart-updated');
                document.getElementById('AjaxCartForm').dispatchEvent(event);

            })
            .catch(e => {
                console.log(e);
                let alert = document.createElement('span');
                alert.classList.add('alert', 'alert--error');
                alert.textContent = KROWN.settings.locales.cart_general_error;
                document.getElementById('AjaxCartForm').prepend(alert);
            })
            .finally(() => {
                document.getElementById('AjaxCartForm').classList.remove('processing');
            });
    }

    function ajaxifyCartItems(cartItemsContainer) {
        cartItemsContainer.querySelectorAll('[data-js-cart-item]').forEach(item => {
            const remove = item.querySelector('.remove');
            if (remove) {       
                remove.dataset.href = remove.getAttribute('href');
                remove.setAttribute('href', '');
                remove.addEventListener('click', (e) => {
                    e.preventDefault();
                    updateCartQty(item, 0);
  
                });
            }

        });
    }

    function rebindAjaxCartForm(cartItemsContainer) {
        if (!cartItemsContainer) return;

        if (typeof cartItemsContainer.ajaxifyCartItems === 'function') {
            cartItemsContainer.ajaxifyCartItems();
        } else if (typeof ajaxifyCartItems === 'function') {
            ajaxifyCartItems(cartItemsContainer);
        }
    }

    function triggerAvailabilityRefresh(options) {
        if (
            typeof window !== 'undefined' &&
            typeof window.itgScheduleAvailabilityRefresh === 'function'
        ) {
            window.itgScheduleAvailabilityRefresh(options);
        }
    }

    async function addProductToCart(productVariantId, quantity = 1) {
        try {

                const properties = {
                   _free_product: 0  
                };

                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: productVariantId,
                        quantity,
                        properties
                    })
                });
                if (!response.ok) {
                    throw new Error(`Cart add failed with status ${response.status}`);
                }

                await updateCartDrawer();
                await updateProgressBar(); 

                // updateCartContents({ showOverlay: true });

                fetch('?section_id=helper-cart')
                    .then((response) => response.text())
                    .then((text) => {

                        // console.log("inside modified fetch") ;
                        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
                        const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;

                        const cartItems = document.getElementById('AjaxCartForm');
                        cartItems.innerHTML = cartFormInnerHTML;
                        rebindAjaxCartForm(cartItems);

                        document
                            .querySelectorAll('[data-header-cart-count]')
                            .forEach((element) => {
                                element.textContent = document.querySelector(
                                    '#AjaxCartForm [data-cart-count]'
                                ).textContent
                            })
                        document
                            .querySelectorAll('[data-header-cart-total]')
                            .forEach((element) => {
                                element.textContent = document.querySelector(
                                    '#AjaxCartForm [data-cart-total]'
                                ).textContent
                            })

                        triggerAvailabilityRefresh({ forceReset: true, delay: 260 });

                    })
                    .catch((error) => {
                        console.error('Error updating cart contents:', error)
                    })

                return true;
            } catch (err) {
                console.error(`Error adding variant ${productVariantId}:`, err);
                return false;
            }
        }

    async function addServiceVariantToCart(productVariantId) {
        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    items: [{ id: productVariantId, quantity: 1 }]
                })
            });

            if (!response.ok) {
                let message = 'Cart add failed';

                try {
                    const payload = await response.json();
                    if (typeof payload?.description === 'string' && payload.description) {
                        message = payload.description;
                    } else if (typeof payload?.message === 'string' && payload.message) {
                        message = payload.message;
                    }
                } catch (_error) {
                    message = `Cart add failed with status ${response.status}`;
                }

                throw new Error(message);
            }

            await updateCartDrawer();
            await updateProgressBar();
        } catch (error) {
            console.error('Error adding to cart:', error);
        }
    }


    async function updateCartDrawer() {
            // console.log("updateCartDrawer functions called") ;
            try {
                const response = await fetch('?section_id=helper-cart');
                const text = await response.text();

                const parser = new DOMParser();
                const doc = parser.parseFromString(text, 'text/html');

                const cartForm = doc.getElementById('AjaxCartForm').innerHTML;
                const cartSubtotal = doc.getElementById('AjaxCartSubtotal').innerHTML;

                const cartItems = document.getElementById('AjaxCartForm');
                cartItems.innerHTML = cartForm;
                rebindAjaxCartForm(cartItems);
                document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotal;

                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = cartSubtotal;

                const cartTotalElem = tempDiv.querySelector(".cart__total");
                const cartTotalNew = cartTotalElem ? cartTotalElem.getAttribute("data-total-price") : 0;

                // console.log(cartTotalNew);

                document.querySelector('.cart_drawer_progress_bar').setAttribute("data-cart-price" , cartTotalNew) ;
                localStorage.setItem('loadedCartPrice', cartTotalNew);

                const cartCount = doc.querySelector('#AjaxCartForm [data-cart-count]').textContent;
                document.querySelectorAll('[data-header-cart-count]').forEach(element => {
                    element.textContent = cartCount;
                });

                const cartTotal = doc.querySelector('#AjaxCartForm [data-cart-total]').textContent;
                document.querySelectorAll('[data-header-cart-total]').forEach(element => {
                    element.textContent = cartTotal;
                });

                triggerAvailabilityRefresh({ forceReset: true, delay: 260 });

            } catch (error) {
                console.error('Error updating cart contents:', error);
            }
            if (typeof window !== 'undefined' && window.__INTERNAL_TEST_MODE__) {
                newUpdateCartDrawer();
            } else {
                setTimeout(()=>{
                    newUpdateCartDrawer() ;
                },1000) ;
            }
    }

    async function removeProductFromCart(productVariantId) {
        if (!itgClickLineRemoveLink(productVariantId)) return;
        try {
            await updateCartDrawer();
        } catch (err) {
            console.error(`Error removing variant ${productVariantId}:`, err);
        }
    }

async function updateProgressBar() {

    const main_progress_wrapper = document.querySelector('.cart_drawer_progress_bar_inner_wrapper');
    if (!main_progress_wrapper) return;

    const cartBar = main_progress_wrapper.querySelector(".cart_drawer_progress_bar");
    const maxAmountPrice = parseFloat(cartBar?.getAttribute("data-maxamt"));
    const cartPrice = parseFloat(cartBar?.getAttribute("data-cart-price"));

    if (isNaN(maxAmountPrice) || isNaN(cartPrice)) return;

    localStorage.setItem('loadedCartPrice', cartPrice);

    const allSteps = main_progress_wrapper.querySelectorAll(".progbar_counter");

    // Fetch current cart once
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    itgSetProgressFill(cartBar, cartPrice, maxAmountPrice);

    const { offersHTML, giftProductIdsInCart } = itgApplyProgressSteps(
        cart, allSteps, cartPrice, maxAmountPrice, removeProductFromCart
    );

    // Duplicated free gifts (e.g. added before the click guard existed) are
    // trimmed back to one unit after rendering; the checkout guard awaits this.
    if (giftProductIdsInCart.length) {
        window.itgFreeGiftState.pendingTrim = itgEnforceFreeGiftLimits(
            cart,
            giftProductIdsInCart.map(productId => ({ productId, allowedUnits: 1 }))
        )
            .then(trimmed => {
                if (trimmed) return updateCartDrawer();
            })
            .catch(err => {
                console.error('Error trimming duplicate free gift:', err);
            });
    }

    itgRenderFreeGiftOffers(offersHTML);
}
